import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { MdClose, MdCheckCircle } from 'react-icons/md';
import { getContracts, getSecondContract } from 'services/contractsServices';
import Loading from 'components/layout/loading';
import theme from 'styles/theme';
import ItemBox from '../ItemBox';

import {
  ButtonRequestContract,
  Container,
  ContractNotFound,
  ContractNotFoundText,
  LoadingContracts,
  TextBold,
  ModalContainer,
  ModalHeader,
  ModalStyle,
} from './styles';
import { ContractData } from './types';

const Contract: React.FC = () => {
  const [siteId, setSiteId] = useState<string>('');
  const [loading, setLoading] = useState<boolean>(false);
  const [contracts, setContracts] = useState<ContractData[]>([]);
  const [loadingContract, setLoadingContract] = useState<boolean>(false);
  const [showModal, setShowModal] = useState<boolean>(false);
  const [protocolNumber, setProtocolNumber] = useState<string>('');

  useEffect(() => {
    async function getSiteId(): Promise<void> {
      const customerSiteId = await localStorage.getItem(
        '@UltragazEmpresarial:customerSiteId'
      );
      if (customerSiteId) {
        setSiteId(customerSiteId);
      }
    }
    if (!siteId) getSiteId();
  }, [siteId]);

  const handleGetContract = useCallback(async () => {
    try {
      setLoadingContract(true);
      const response = await getSecondContract();
      setProtocolNumber(response.caseNumber);
      setLoadingContract(false);
      setShowModal(true);
    } catch (error) {
      setLoadingContract(false);
    }
  }, [setLoadingContract]);

  useEffect(() => {
    async function getContractFirst(): Promise<void> {
      setLoading(true);
      const response = await getContracts(siteId);
      setLoading(false);
      setContracts(response);
    }
    if (siteId) getContractFirst();
  }, [siteId]);

  const listItems = useMemo(() => {
    if (contracts?.length === 0) return [];
    return contracts?.filter(
      (conctract) => conctract.contractType === 'Contrato'
    );
  }, [contracts]);

  return (
    <Container>
      {loadingContract && <Loading />}
      {loading && (
        <LoadingContracts>Carregando contratos, aguarde...</LoadingContracts>
      )}
      {!loading && listItems?.length > 0 && (
        <>
          {listItems.map((contractItem) => (
            <ItemBox item={contractItem} siteId={siteId} />
          ))}
        </>
      )}
      {!loading && listItems?.length === 0 && (
        <ContractNotFound>
          <ContractNotFoundText>
            <span>Seu contrato ainda não está disponível.</span>
            <span>
              Para abrir uma solicitação para o setor comercial, clique no botão
              <TextBold> solicitar 2ª via.</TextBold>
            </span>
          </ContractNotFoundText>
          <ButtonRequestContract onClick={() => handleGetContract()}>
            Solicitar 2ª via
          </ButtonRequestContract>
        </ContractNotFound>
      )}
      <ModalStyle
        show={showModal}
        onHide={() => {
          setShowModal(false);
        }}
        centered
      >
        <ModalContainer>
          <ModalHeader>
            <div>
              <MdCheckCircle size={50} color={theme.colors.lightGreen} />
              <p
                dangerouslySetInnerHTML={{
                  __html: `
                Sua solicitação sobre
                <b> 2ª via de contrato </b>
                foi registrada através do protocolo:
                <b> ${protocolNumber} </b>. O setor comercial retornará o contato
                no prazo máximo de até
                <b> 5 dias úteis </b>
                através do seu
                <b> e-mail cadastrado e/ou telefone.</b>
              `,
                }}
              />
              <MdClose
                size={24}
                onClick={() => {
                  setShowModal(false);
                }}
              />
            </div>
          </ModalHeader>
        </ModalContainer>
      </ModalStyle>
    </Container>
  );
};

export default Contract;
